import { ReactComponent as PlaceholderChecklistsIcon } from '@cobliteam/ui/icons/placeholder/placeholder-checklists.svg';

import cn from '../../../../utils/cn';
import Typography from '../../../Typography';

export interface DropdownBodyPlaceholderProps {
  icon?: React.FC<React.SVGProps<SVGSVGElement>>;
  text?: string;
  className?: string;
}

const DropdownBodyPlaceholder = ({ text, icon: Icon, className }: DropdownBodyPlaceholderProps) => (
  <div className={cn('px-auto  flex h-52 flex-col items-center justify-center', className)}>
    {Icon ? <Icon className='h-16 w-16' /> : <PlaceholderChecklistsIcon className='mb-2 h-16 w-16' />}
    <Typography variant='body' color='secondary'>
      {text || 'Não existe dados.'}
    </Typography>
  </div>
);

export default DropdownBodyPlaceholder;
